import { render, staticRenderFns } from "./CurrencySelect.vue?vue&type=template&id=6f96723a&scoped=true&"
import script from "./CurrencySelect.vue?vue&type=script&lang=ts&"
export * from "./CurrencySelect.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencySelect.vue?vue&type=style&index=0&id=6f96723a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f96723a",
  null
  
)

export default component.exports